var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-skeleton-wrapper',{attrs:{"loading":_vm.loading},scopedSlots:_vm._u([{key:"loading",fn:function(){return [_c('div',{staticClass:"flex"},_vm._l((_vm.items),function(item,index){return _c('b-skeleton',{key:`a-${index}`,staticClass:"margin-left-8",attrs:{"width":"25%","height":"24px"}})}),1)]},proxy:true}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }